import { render, staticRenderFns } from "./OnlinerateManagerData.vue?vue&type=template&id=8bf76296&scoped=true"
import script from "./OnlinerateManagerData.vue?vue&type=script&lang=js"
export * from "./OnlinerateManagerData.vue?vue&type=script&lang=js"
import style0 from "./OnlinerateManagerData.vue?vue&type=style&index=0&id=8bf76296&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf76296",
  null
  
)

export default component.exports